import React from 'react';
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
// import Create from './pages/Create';
// import Edit from './pages/Edit';

export default function ResourcesWorkSchedule(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/work-schedule',
      component: Index,
      isProtected: true,
      permissions: ['work_schedule_index']
    },
    {
      path: '/work-schedule/create',
      component: Create,
      isProtected: true,
      permissions: ['work_schedule_create']
    },
    {
      path: '/work-schedule/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['work_schedule_edit']
    },

  ];

  return routes;
}